import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';

import { FunctionService  } from 'vhobjects-service';
import { JsonDataService } from 'vhobjects-service/src/services';

@Component({
  selector: 'app-add-menu-vertical-admin',
  templateUrl: './add-menu-vertical-admin.component.html',
  styleUrls: ['./add-menu-vertical-admin.component.scss']
})

export class AddMenuVerticalAdminComponent implements OnInit {
  @Input() data: any;
  @Input() type: any; // dữ liệu menu từ component cha truyền vào
  @Output() isAddMenu = new EventEmitter();
  @Output() isEditMenu = new EventEmitter();
  @Output() valueData = new EventEmitter();
  @Output() valueDataEdited = new EventEmitter();

  // Mảng danh sách group (link/category/pop-up)
  listGroupLink = [
    {
      url: 'link',
      name: 'duong_dan'
    },
    {
      url: 'category',
      name: 'goi_danh_muc'
    },
    {
      url: 'pop-up',
      name: 'goi_hop_thoai'
    }
  ];
  // Mảng danh sách type (none/link-page/website/link-url/category)
  listLink = [
    {
      url: 'none',
      name: 'khong'
    },
    {
      url: 'link-page',
      name: 'den_trang'
    },
    {
      url: 'website',
      name: 'lien_ket'
    },
    {
      url: 'link-url',
      name: 'link_san_pham'
    }
  ]

  listBlockPopup = []; // biến chứa dữ liệu các Khối hộp thoại (popup)
  listLinkPage = []; // biến chứa dữ liệu các Trang liên kết (link-page)
  listPageCategory: any = []; // biến chứa dữ liệu các Trang danh mục (category)
  isValid: boolean = false; // Biến này xác định form đã valid hay chưa (true: valid; false: chưa)
  resolution: any;
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private jsonDataService: JsonDataService,
    public functionService: FunctionService
  ) {
  }

  ngOnInit(): void {
    // Lấy dữ liệu
    this.getBlockHoverBlank();
    this.getLinkPage();
    this.getPageOfCate();

    this.resolution = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    ).resolution;
  }

  /**
   * Lấy danh sách các Trang liên kết (link-page)
   */
  getLinkPage() {
    this.vhQueryAutoWeb.getPages_byFields({ type: { $in: ['blank', 'homepage', 'detail_category'] } }).then((pages:any) => {
      Promise.all(
        pages.map((page: any) => {
          return this.vhQueryAutoWeb.getCommonDatas_byFields({ id_page: { $eq: page._id } })
            .then((commonData) => {
              page.link = commonData[0]?.link ?? page.link;
              page.name = commonData[0]?.name ?? page.name;
              return page; // Trả về page sau khi cập nhật
            });
        })
      ).then((updatedPages) => {
        this.listLinkPage = updatedPages;
      })
    });
  }

  /**
   * Lấy danh sách các Trang danh mục (category)
   */
  getPageOfCate() {
    this.vhQueryAutoWeb.getPages_byFields({type: {$eq: 'detail_category'}}).then(
      (pages: Array<any>) => {
        Promise.all(
          pages.map((page: any) => {
            return this.vhQueryAutoWeb.getCommonDatas_byFields({ id_page: { $eq: page._id } })
              .then((commonData) => {
                page.link = commonData[0]?.link ?? page.link;
                page.name = commonData[0]?.name ?? page.name;
                return page; // Trả về page sau khi cập nhật
              });
          })
        ).then((updatedPages) => {
          this.listPageCategory = updatedPages;
        });
      });
  }

  /**
   * Lấy danh sách các Khối hộp thoại (popup)
   */
  getBlockHoverBlank() {
    this.vhQueryAutoWeb.getBlocks_byFields({ type: { $in: ['menu_hover', 'hover_blank'] } })
      .then((blocks: any) => {
        this.listBlockPopup = blocks;
      })
  }

  /**
   * Bắt sự kiện thay đổi group và type
   */
  changeGroupAndType() {
    // reset các trường
    this.data.menu.id_page_category = null;
    this.data.menu.id_freeblock = null;
    this.data.menu.link_page = null;
    this.data.menu.link_website = null;
    this.data.menu.link_url = null;
    this.onChangeAttr();
  }

  /**
   * Bắt sự kiện thay đổi các trường trong from
   */
  onChangeAttr() {
    const menu = this.data.menu;

    setTimeout(() => {
      if (!menu) return;

      const isValidBody =
          (menu.type === 'none') ||
          (menu.type === 'link-page' && menu.link_page != null) ||
          (menu.type === 'website' && menu.link_website) ||
          (menu.type === 'link-url' && menu.link_url);

      // Do group === 'category' sẽ có trường riêng là id_page_category và group === 'pop-up' sẽ có trường riêng là id_freeblock, phần còn lại sẽ giống với group === 'link' nên mới dùng cách validate theo group
      // Validate theo group (link, category, pop-up)
      const isValidLink = (menu.group === 'link' && isValidBody);
      const isCategoryValid = (menu.group === 'category' && menu.id_page_category != null && isValidBody);
      const isPopUpValid = (menu.group === 'pop-up' && menu.id_freeblock != null && isValidBody);

      this.isValid = menu['name_' + this.functionService.selectedLanguageCode] && (isValidLink || isCategoryValid || isPopUpValid);
    }, 50)
  }

  /**
   * Lưu giá trị form thêm menu
   */
  saveFormAddMenu() {
    // Xóa các trường không cần
    const menu = this.data.menu;
    // Xóa theo type
    const typeFieldsToDeleteMap = {
      'none': ['link_page', 'link_website', 'link_url'],
      'link-page': ['link_website', 'link_url'],
      'website': ['link_page', 'link_url'],
      'link-url': ['link_website', 'link_page']
    };
    // Xóa theo group
    const groupFieldsToDeleteMap = {
      'link': ['id_page_category', 'id_freeblock'],
      'category': ['id_freeblock'],
      'pop-up': ['id_page_category']
    };
    // Mảng chứa các trường cần xóa
    const fieldsToDelete = typeFieldsToDeleteMap[menu.type] || [];
    fieldsToDelete.push(...groupFieldsToDeleteMap[menu.group] || []);
    // Xóa
    this.deleteFields(menu, fieldsToDelete);

    if (!this.data.menu._id) {
      this.data.menu["children"] = [];
      this.data.menu["level"] = 0;
      this.data.menu['_id'] = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); // tạo _id ngẫu nhiêu với 4 kí tự
    }


    // Gửi dữ liệu đi
    this.valueData.emit(this.data);
    this.isAddMenu.emit(false);
  }

  /**
   * Xóa các trường trong object
   * @param {Object} data - Object có trường cần xóa
   * @param {Array} fieldsToDelete - Mảng chứa tên các trường cần xóa
   */
  deleteFields(data, fieldsToDelete) {
    fieldsToDelete.forEach(field => {
      delete data[field];
    });
  }

  /**
   * Đóng form thêm menu
   */
  cancelFormAddMenu() {
    this.isAddMenu.emit(false);
  }


  createNewBlock() {
    this.jsonDataService
        .getBlock('hover_blank')
        .subscribe((result: any) => {
          if(result) {
            let dataBlock = {
              ...result,
              name: result.name + ' ' + (this.listBlockPopup.length + 1),
              ['desktop_position_']: {
                ...result['desktop_position'],
                width: this.resolution['desktop_width'] - 1,
              },
              ['mobile_portrait_position_']: {
                ...result['mobile_portrait_position'],
                width: this.resolution['mobile_portrait_width'] - 1,
              },
              ['tablet_landscape_position_']: {
                ...result['tablet_landscape_position'],
                width: this.resolution['tablet_landscape_width'] - 1,
              },
              ['tablet_portrait_position_']: {
                ...result['tablet_portrait_position'],
                width: this.resolution['tablet_portrait_width'] - 1,
              },
              ['mobile_landscape_position_']: {
                ...result['mobile_landscape_position'],
                width: this.resolution['mobile_landscape_width'] - 1,
              },
              type: 'hover_blank',
            };

            
            dataBlock.desktop_class[result.resize_field]['width'] = (this.resolution['desktop_width'] -1)+'px';
            dataBlock.desktop_class[result.resize_field]['min-height'] = result['desktop_position'].height+'px'

            dataBlock.mobile_portrait_class[result.resize_field]['width'] = (this.resolution['mobile_portrait_width'] - 1)+'px';
            dataBlock.mobile_portrait_class[result.resize_field]['min-height'] = result['mobile_portrait_position'].height+'px'

            dataBlock.mobile_landscape_class[result.resize_field]['width'] = (this.resolution['mobile_landscape_width'] - 1)+'px';
            dataBlock.mobile_landscape_class[result.resize_field]['min-height'] = result['mobile_landscape_position'].height+'px'

            dataBlock.tablet_landscape_class[result.resize_field]['width'] = (this.resolution['tablet_landscape_width'] - 1)+'px';
            dataBlock.tablet_landscape_class[result.resize_field]['min-height'] = result['tablet_landscape_position'].height+'px'

            dataBlock.tablet_portrait_class[result.resize_field]['width'] = (this.resolution['tablet_portrait_width'] -1)+'px';
            dataBlock.tablet_portrait_class[result.resize_field]['min-height'] = result['tablet_portrait_position'].height+'px'



            dataBlock.desktop_config.dimension = {
              width: this.resolution['desktop_width'] - 1,
              height: result['desktop_position'].height
            }
            dataBlock.mobile_portrait_config.dimension = {
              width: this.resolution['mobile_portrait_width'] - 1,
              height: result['mobile_portrait_position'].height
            }
            dataBlock.mobile_landscape_config.dimension = {
              width: this.resolution['mobile_landscape_width'] - 1,
              height: result['mobile_landscape_position'].height
            }
            dataBlock.tablet_landscape_config.dimension = {
              width: this.resolution['tablet_landscape_width'] - 1,
              height: result['tablet_landscape_position'].height
            }
            dataBlock.tablet_portrait_config.dimension = {
              width: this.resolution['tablet_portrait_width'] - 1,
              height: result['tablet_portrait_position'].height
            }

            this.vhQueryAutoWeb.addBlock(dataBlock)
              .then((block: any) => {
              this.listBlockPopup.push(block);
              this.functionService.createMessage('success', 'them_khoi_thanh_cong');
            })
          }
        });
  }
}
